import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';

const SuperAdminRoute = ({ children }) => {
  const { isAdminAuthenticated, loading } = useAdminAuth();
  const location = useLocation();

  useEffect(() => {
    document.body.classList.remove('light-mode');
    document.documentElement.classList.remove('light-mode');
    document.body.classList.add('dark-mode');
    document.documentElement.classList.add('dark-mode');
    document.body.style.backgroundColor = '#0b1329';
  }, []);

  if (loading && !isAdminAuthenticated) {
    return (
      <div
        style={{
          minHeight: '100vh',
          width: '100%',
          backgroundColor: '#0b1329',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#f8fafc',
          fontFamily: 'Inter, system-ui, sans-serif'
        }}
      >
        <div
          style={{
            width: '44px',
            height: '44px',
            border: '3px solid rgba(16, 185, 129, 0.2)',
            borderTopColor: '#10b981',
            borderRadius: '50%',
            animation: 'adminRouteSpin 0.8s linear infinite',
            marginBottom: '1.25rem'
          }}
        />
        <div style={{ fontSize: '0.95rem', fontWeight: 600, color: '#94a3b8' }}>
          Loading Super Admin Portal...
        </div>
        <style>{`
          @keyframes adminRouteSpin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!isAdminAuthenticated) {
    return <Navigate to="/superadmin/login" state={{ from: location }} replace />;
  }

  return children;
};

export default SuperAdminRoute;
